import React from 'react';

import type { ILocationV2 } from '@sravni/types/lib/locations';
import type { Seo } from '@sravni/types/lib/seo';

import type { List } from '@src/@types/microcredits';
import { useSelectCreditsList } from '@src/reducers/microcredits';
import type { ISeoSchemaOptions } from 'entities/Seo/types';

import { SeoSchema } from './SeoSchema';

const DEFAULT_CONFIG: Omit<ISeoSchemaOptions, 'listKey'> = {
  product: true,
};

interface Props {
  seo: Seo;
  path: string;
  currentLocation: ILocationV2;
  metadata: List.IMetadata;
  config: ISeoSchemaOptions;
}

export const SeoListSchema = ({ config, seo, path, currentLocation, metadata }: Props) => {
  const microcredits = useSelectCreditsList(config.listKey);

  const localConfig = { ...DEFAULT_CONFIG, ...config };

  return (
    <SeoSchema
      seo={seo}
      microcredits={localConfig.product ? microcredits : undefined}
      path={path}
      currentLocation={currentLocation}
      metadata={metadata}
      product={localConfig.product}
    />
  );
};
